export default {
  title: 'Storefront',
  fields: {
    has_reservations: {
      label: 'Reserveringen tonen op Storefront',
    },
  },
  button: {
    save: 'Opslaan',
    preview: 'Voorbeeld',
  },
  no_storefront: {
    title: 'Geen Storefront gevonden',
    description: 'Maak een Storefront aan.',
    button: {
      storefront: 'Naar Storefront',
    },
  },
  response_messages: {
    success: 'Succesvol bijgewerkt.',
    failed: 'Bijwerken mislukt.',
  },
};
